import { render, staticRenderFns } from "./ListadoSeccionesTabla.vue?vue&type=template&id=b182ea0a"
import script from "./ListadoSeccionesTabla.vue?vue&type=script&lang=js"
export * from "./ListadoSeccionesTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports